"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllTicketPipelines = exports.createGetAllTicketPipelines = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _immutable = require("immutable");

var _formatPipelines = _interopRequireDefault(require("reference-resolvers/formatters/formatPipelines"));

var _formatPipelineStages = _interopRequireDefault(require("reference-resolvers/formatters/formatPipelineStages"));

var formatResponse = function formatResponse(response) {
  return (0, _immutable.Map)({
    pipelines: (0, _formatPipelines.default)(response),
    stages: (0, _formatPipelineStages.default)(response)
  });
};

var createGetAllTicketPipelines = function createGetAllTicketPipelines(_ref) {
  var httpClient = _ref.httpClient;
  return function () {
    return httpClient.get('pipelines/v2/pipelines/TICKET').then(formatResponse);
  };
};

exports.createGetAllTicketPipelines = createGetAllTicketPipelines;
var getAllTicketPipelines = createGetAllTicketPipelines({
  httpClient: _apiClient.default
});
exports.getAllTicketPipelines = getAllTicketPipelines;